<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/vertical-solutions']">
        <span translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>COMMONS.CRYPTER_SALES_MODULES</span>
</div>

<tb-header specificTitle="COMMONS.CRYPTER_SALES_MODULES"></tb-header>
<div class="contentGlobal" style="text-align: left">
    <mat-card class="vertical-solution-card" style="text-align: center">
        <mat-card-header>
            <div style="display: flex; justify-content: space-between; width: 100%">
                <mat-card-title translate>COMMONS.CRYPTER_SALES_MODULES</mat-card-title>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="text-left" [innerHtml]="this.cryptSalesModuleIntroduction"></div>
            <div style="display: flex; flex-direction: column; justify-content: center; flex-wrap: wrap"  *ngIf="!noSolutions">
                <div style="margin-top: 3rem">
                    <mat-form-field appearance="outline">
                        <mat-label><span translate> VERTICAL_SOLUTIONS.CHOOSE_SOLUTION</span></mat-label>
                        <mat-select
                            ngModel
                            name="selectSolutionName"
                            [(ngModel)]="selectedValue"
                            (selectionChange)="onSolutionChange($event)"
                        >
                            <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                            <mat-option *ngFor="let c of this.verticalSolutionList" [value]="c.Signature">
                                {{ c.Signature }} - {{ c.Description }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div style="text-align: left">
                    <button
                        mat-flat-button
                        matTooltipClass="tooltip-layout"
                        class="button-icon-text"
                        color="primary"
                        (click)="fileUpload.click()"
                        *ngIf="uploadButtonVisible"
                    >
                        <span translate> VERTICAL_SOLUTIONS.SELECT_FILE_TO_CRYPT</span><mat-icon>upload_file</mat-icon>
                    </button>
                    <div *ngIf="tableFilesVisible" class="table-upload">
                        <div
                            *ngFor="let file of uploadedFiles"
                            style="display: flex; flex-direction: row; justify-content: space-between"
                            class="table-upload-row"
                        >
                            <div style="min-width: 500px; padding: 0.8rem">{{ file.name }}</div>
                            <div style="display: flex; flex-direction: row">
                                <div style="min-width: 200px; padding: 0.8rem">{{ file.size }} bytes</div>
                                <div style="min-width: 100px; padding: 0.3rem; float: right">
                                    <button mat-mini-fab color="primary" class="upload-btn" (click)="delete(file)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <input
                        type="file"
                        class="file-input"
                        multiple
                        [accept]="requiredFileType"
                        (change)="onFileSelected($event)"
                        #fileUpload
                    />
                </div>
                <div style="margin-top: 0.5rem; margin-left: 0.5rem; margin-top: 2rem">
                    <button mat-flat-button color="primary" (click)="crypt()" *ngIf="cryptButtonVisible" [disabled]="setDisabled()">
                        <span translate>VERTICAL_SOLUTIONS.CRYPT</span>
                    </button>
                </div>

                <div class="message-box error" *ngIf="isError">
                    <span>{{ this.messageBoxMessage }}</span>
                </div>
            </div>

            <div class="message-box warning"  style="text-align: left" *ngIf="noSolutions">
              <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
            </div>
          </mat-card-content>
    </mat-card>
</div>
<div *ngIf="this.loading">
  <tb-loading></tb-loading>
</div>
